// DataComponent.tsx
import { useEffect, useState } from 'react';
import { useDataContext } from './Contexts/DataContext';
import { ComboBox, Item, Key } from '@adobe/react-spectrum';
import { DataComponentProps } from './DataComponentProps';

interface ActivityDropDownProps extends DataComponentProps {
    parent_project_id?: number;
    parent_activity_id?: number;
}
const ActivityDropDown: React.FC<ActivityDropDownProps> = ({ 
    parent_project_id,
    parent_activity_id,
    compKey, 
    label, 
    width, 
    isRequired, 
    onValueChange ,
    value: dvalue
}) => {
  const message = `${label} is required`;
  const [errorMessage, setErrorMessage] = useState(isRequired ? message : '');
  const [value, setValue] = useState<Key | null>('');
  const [input, setInput] = useState('');
  const { getActivityData } = useDataContext();
  const { data, error, loading } = getActivityData({ parent_project_id, parent_activity_id });

  useEffect(() => {
    if(dvalue && dvalue != 'undefined') {
        setValue(dvalue);
    }
  },[dvalue]);
  
  const onSelectionChange = (value: Key | null) => {
    if(onValueChange)
        onValueChange(value ? value.toString() : '', input);
    setValue(value);
    if(isRequired && !value) 
      setErrorMessage(message);
    else 
      setErrorMessage('');
  };

  const onInputChange = (value: string) => {
    setInput(value);
  }
  
  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;

  return (
    <ComboBox key={compKey} 
        label={label} 
        width={width} 
        isRequired={isRequired} 
        selectedKey={value}
        onSelectionChange={onSelectionChange} 
        onInputChange={onInputChange}
        validationState={errorMessage ? 'invalid' : undefined}
        errorMessage={errorMessage}
        >
      {data.map((item) => (
        <Item key={item.id} textValue={item.title}>
          {item.title}
        </Item>
      ))}
    </ComboBox>
  );
};

export default ActivityDropDown;
